import { useQuery } from '@tanstack/react-query';

import { getEmployeeDashboard } from '../../../shared/api/employee.service';
import { useEmployeeSession } from '../../../shared/hooks/use-employee-session';

import { resolveTipsShareQrUrl } from './tips-share-qr';

function resolveEmployeeDashboardTimeZone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone ?? '';
  } catch {
    return '';
  }
}

export function useTipsShareQrUrl(): string | null {
  const { status } = useEmployeeSession();
  const dashboardQuery = useQuery({
    enabled: status === 'authenticated',
    queryFn: () => getEmployeeDashboard(resolveEmployeeDashboardTimeZone()),
    queryKey: ['employee', 'dashboard'],
  });

  return resolveTipsShareQrUrl(dashboardQuery.data?.wallet.uuid ?? null);
}
